export class CertificateExtension {
  constructor(private readonly name: string, private readonly value: string, private readonly critical: boolean | null) {}

  getName() {
    return this.name;
  }

  getValue() {
    return this.value;
  }

  getCritical() {
    return this.critical;
  }
}
